import { Button, ButtonGroup } from "@blueprintjs/core";
import { faGlobeAmericas, faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, HoverCard } from "@mantine/core";

import { TeamsTierUpsell } from "@components/TeamsTierUpsell";

export function VisibilityToggle({
  hasTeamsTier,
  visibility,
  setAction,
}: {
  hasTeamsTier: boolean;
  visibility: string;
  setAction: (action: "unlisted" | "org_private") => void;
}) {
  return (
    <ButtonGroup style={{ height: "40px" }}>
      {!hasTeamsTier && visibility !== "org_private" ? (
        <HoverCard position="bottom">
          <HoverCard.Target>
            <div>
              <Button
                style={{ height: "100%" }}
                intent="none"
                active={false}
                disabled={true}
              >
                Private
              </Button>
            </div>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Box sx={{ width: "280px" }} p="md">
              <TeamsTierUpsell />
            </Box>
          </HoverCard.Dropdown>
        </HoverCard>
      ) : (
        <Button
          intent="none"
          active={visibility === "org_private"}
          onClick={
            visibility !== "org_private"
              ? () => setAction("org_private")
              : undefined
          }
          title="Rule is visible and accessible only to your organization."
          icon={<FontAwesomeIcon icon={faLock} size="sm" />}
        >
          Private
        </Button>
      )}
      <Button
        intent="none"
        active={visibility === "unlisted"}
        onClick={
          visibility !== "unlisted" ? () => setAction("unlisted") : undefined
        }
        title="Rule is visible to anyone with the link."
        icon={<FontAwesomeIcon icon={faGlobeAmericas} size="sm" />}
      >
        {/* This is just label - "public" here means "unlisted" in data */}
        Public
      </Button>
    </ButtonGroup>
  );
}
